var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmarkFilled = function SvgBookmarkFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5554 18.3335L9.99989 14.8613L4.44434 18.3335V3.05577C4.44434 2.87159 4.5175 2.69496 4.64773 2.56473C4.77797 2.43449 4.9546 2.36133 5.13878 2.36133H14.861C15.0452 2.36133 15.2218 2.43449 15.352 2.56473C15.4823 2.69496 15.5554 2.87159 15.5554 3.05577V18.3335Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBookmarkFilled;